var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column px-7 py-5"},[_vm._t("rowCell")],2)}
var staticRenderFns = []

export { render, staticRenderFns }